module.exports = __webpack_public_path__ + "static/media/street-view.7421adef.svg";